/* eslint-disable @typescript-eslint/no-empty-function */
import { ElementRef } from '@angular/core';
import { DestroyableComponent } from 'src/app/core/destroyable.component';

export interface ModalDefaultModel {
  defaultTitle?: string;
  defaultContent?: string;
  defaultDismissButtonLabel?: string;
}

export abstract class SkyModalController<M = { [key: string]: any }, T = null> extends DestroyableComponent {
  public modalWrapperRef!: ElementRef;
  public model = {} as ModalDefaultModel & M;
  public close(): void {}
  public confirm(payload: T | null = null): void {}
}
